export default "__VITE_ASSET__BjM5d8nL__"